import Swiper from 'swiper';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default () => {
    const testimonialsSidebarSwiper = new Swiper('.testimonials-sidebar-slider', {
        pagination: {
        el: '.swiper-pagination',
        clickable: true,
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: true
        },        
        a11y: true,
        keyboardControl: true,
        grabCursor: true,
        autoHeight: true,
    });

    //  listen for browser size changes 
    // window.onresize = function() {
    //     testimonialsSidebarSwiper.update();
    // }
};